import {
  Collapse,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RCheckbox } from "../ratifikaElements";
import { setConfigParam } from "../../store/actions/config";
import { fetch } from "../../store/fetch";
import Autosuggest from "react-autosuggest";
import axios from "axios";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

interface Contributor {
  number_type: string;
  number: string;
  legal_name: string;
  id: number;
}
export const FilterReport = ({ showAlert }: { showAlert: any }) => {
  const dispatch = useDispatch();
  const config = useSelector((state: any) => state.config);

  const [filterSerie, setFilterSerie] = React.useState<string>(
    config.reportFilterSerie || ""
  );
  const [filterInitSeq, setFilterInitSeq] = React.useState<string>(
    config.reportFilterInitSeq || ""
  );
  const [filterEndSeq, setFilterEndSeq] = React.useState<string>(
    config.reportFilterEndSeq || ""
  );
  const filteredDocTypes = config.typeDoc ? config.typeDoc.split(",") : [];
  const [validSerie, setValidSerie] = React.useState<boolean | null>(null);
  const [validFilterInitSeq, setValidFilterInitSeq] = React.useState<
    boolean | null
  >(null);
  const [validFilterEndSeq, setValidFilterEndSeq] = React.useState<
    boolean | null
  >(null);
  const [docTypes, setDocTypes] = React.useState({
    Facturas: filteredDocTypes.includes("01"),
    Boletas: filteredDocTypes.includes("03"),
    NotasCredito: filteredDocTypes.includes("07"),
    NotasDebito: filteredDocTypes.includes("08"),
  });

  const handleCheckDocType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDocTypes({ ...docTypes, [event.target.name]: event.target.checked });
  };
  const filteredDocStates = config.stateDoc
    ? config.stateDoc.replace("1-3", "1,3").split(",")
    : [];

  const [docStates, setDocStates] = React.useState({
    Autorizado:
      filteredDocStates.includes("1") || filteredDocStates.includes("3"),
    Anulado: filteredDocStates.includes("2"),
    Pendiente: filteredDocStates.includes("0"),
    Erroneo: filteredDocStates.includes("-1"),
    Rechazado: filteredDocStates.includes("-2"),
  });
  const handleCheckDocStates = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDocStates({ ...docStates, [event.target.name]: event.target.checked });
  };
  /*Cliente buyer*/
  const [availableCustomers, setAvailableCustomers] = useState<
    Array<Contributor>
  >([]);
  const [autocompleteCustomers, setAutocompleteCustomers] = useState<
    Array<Contributor>
  >([]);
  const [buyerKey, setBuyerKey] = useState<string>(
    config.emittedClientReportName || ""
  );
  const [filterClientId, setfilterClientId] = React.useState<number | null>(
    null
  );

  /*Collapse filter */
  const [collapseNumeral, setCollapseNumeral] = React.useState(true);
  const [collapseState, setCollapseState] = React.useState(true);
  const [collapseDocType, setCollapseDocType] = React.useState(true);
  const [name, setName] = useState<string | null>("");

  useEffect(() => {
    handleFilterReport();
  }, [
    docTypes,
    docStates,
    filterSerie,
    filterInitSeq,
    filterEndSeq,
    filterClientId,
  ]);
  useEffect(() => {
    if (config.workspace) {
      async function fetchCostumers() {
        const { data } = await axios.get<Contributor[]>(
          `api/documents/customer/${config.workspace}?dateOf=${
            config.typeDate
          }&startDate=${config.reportStartDate}&endDate=${
            config.reportEndDate
          }${
            config.reportFilterSerie
              ? `&serie=${config.reportFilterSerie}&seqInit=${config.reportFilterInitSeq}&seqEnd=${config.reportFilterEndSeq}`
              : ""
          }${config.typeDoc ? `&docType=${config.typeDoc}` : ""}${
            config.stateDoc
              ? `&docStatus=${
                  config.stateDoc.split(",").includes("1-3")
                    ? config.stateDoc.replace("1-3", "1,3")
                    : config.stateDoc
                }`
              : ""
          }`
        );
        setAvailableCustomers(data);
      }

      fetchCostumers();
    }
  }, [
    config.workspace,
    config.typeDate,
    config.reportStartDate,
    config.reportEndDate,
    config.reportFilterSerie,
    config.reportFilterInitSeq,
    config.reportFilterEndSeq,
    config.typeDoc,
    config.stateDoc,
  ]);

  //FILTRAR REPORTE
  const handleFilterReport = () => {
    let hasErrors = false;
    if (filterSerie && filterSerie.trim().length !== 4) {
      setValidSerie(false);
      hasErrors = true;
    }
    if (filterInitSeq && Number(filterInitSeq) === 0) {
      setValidFilterInitSeq(false);
      hasErrors = true;
    }
    if (filterEndSeq && Number(filterEndSeq) < Number(filterInitSeq)) {
      setValidFilterEndSeq(false);
      hasErrors = true;
    }

    if ((filterInitSeq || filterEndSeq) && !filterSerie) {
      setValidSerie(false);
      hasErrors = true;
    }

    // Init Seq should have a value if serie or end seq have some value
    if ((filterSerie || filterEndSeq) && !filterInitSeq) {
      setValidFilterInitSeq(false);
      hasErrors = true;
    }
    // End Seq should have a value if serie or init seq have some value
    if ((filterSerie || filterInitSeq) && !filterEndSeq) {
      setValidFilterEndSeq(false);
      hasErrors = true;
    }

    if (!hasErrors) {
      // Set filter series/sequentials
      dispatch(setConfigParam("reportFilterSerie", filterSerie));
      dispatch(setConfigParam("reportFilterInitSeq", filterInitSeq));
      dispatch(setConfigParam("reportFilterEndSeq", filterEndSeq));

      // Set filter doc type
      let filteredDocTypes = "";
      if (docTypes.Facturas) {
        filteredDocTypes = "01";
      }
      if (docTypes.Boletas) {
        filteredDocTypes += filteredDocTypes ? ",03" : "03";
      }
      if (docTypes.NotasCredito) {
        filteredDocTypes += filteredDocTypes ? ",07" : "07";
      }
      if (docTypes.NotasDebito) {
        filteredDocTypes += filteredDocTypes ? ",08" : "08";
      }
      dispatch(setConfigParam("typeDoc", filteredDocTypes));
      // Set filter doc state
      let filteredDocStates = "";
      if (docStates.Autorizado) {
        filteredDocStates = "1-3";
      }
      if (docStates.Anulado) {
        filteredDocStates += filteredDocStates ? ",2" : "2";
      }
      if (docStates.Pendiente) {
        filteredDocStates += filteredDocStates ? ",0" : "0";
      }
      if (docStates.Erroneo) {
        filteredDocStates += filteredDocStates ? ",-1" : "-1";
      }
      if (docStates.Rechazado) {
        filteredDocStates += filteredDocStates ? ",-2" : "-2";
      }
      dispatch(setConfigParam("stateDoc", filteredDocStates));

      dispatch(setConfigParam("emittedClientReport", filterClientId));
      dispatch(setConfigParam("emittedClientReportName", name));

      fetch(["reports"]);
      showAlert(true);
    }
  };

  /*Autocomplete*/
  const getCustomersSuggestions = async (
    value: string
  ): Promise<Contributor[]> => {
    const inputValue = value.trim();
    const inputLength = inputValue.length;
    let results = [];

    if (Number.isInteger(Number(inputValue))) {
      // posiblemente sea un RUC
      results =
        inputLength === 0
          ? []
          : availableCustomers
              .filter(
                (contrib) => contrib.number.slice(0, inputLength) === inputValue
              )
              .sort((a, b) => {
                return (
                  a.number.indexOf(inputValue) - b.number.indexOf(inputValue)
                );
              });
    } else {
      // Posiblemente sea un nombre legal
      results =
        inputLength === 0
          ? []
          : availableCustomers
              .filter((contrib) =>
                contrib.legal_name
                  .toLowerCase()
                  .includes(inputValue.toLowerCase())
              )
              .sort((a, b) => {
                return (
                  a.legal_name.indexOf(inputValue) -
                  b.legal_name.indexOf(inputValue)
                );
              });
    }

    return results;
  };

  const getSuggestionValue = (suggestion: Contributor) => {
    //setIdentification(suggestion.number);
    //setDocType(suggestion.number_type);

    setName(suggestion.legal_name);
    setfilterClientId(suggestion.id);
    return suggestion.legal_name || suggestion.number;
  };

  const renderSuggestion = (suggestion: Contributor, { query }: any) => {
    const handleNumber = Number.isInteger(Number(query));
    const suggestionText = handleNumber
      ? suggestion.number
      : suggestion.legal_name;

    const indexOfSuggestion = suggestionText
      .toLowerCase()
      .indexOf(query.toLowerCase());
    const substring = suggestionText.substring(
      indexOfSuggestion,
      indexOfSuggestion + query.length
    );
    const highlight = suggestionText.replace(
      substring,
      `<strong ${
        handleNumber ? `style="font-size: 11px"` : ""
      }>${substring}</strong>`
    );
    return (
      <div>
        {!handleNumber ? (
          <span dangerouslySetInnerHTML={{ __html: highlight }}></span>
        ) : (
          <span style={{ fontSize: 11 }}>{suggestion.legal_name}</span>
        )}
        <br></br>
        {handleNumber ? (
          <span
            style={{ fontSize: 11 }}
            dangerouslySetInnerHTML={{ __html: highlight }}
          ></span>
        ) : (
          <strong style={{ fontSize: 11 }}>{suggestion.number}</strong>
        )}
      </div>
    );
  };

  const onSuggestionsFetchRequested = async (param: any) => {
    setAutocompleteCustomers(await getCustomersSuggestions(param.value));
    // console.log(autocompleteCustomers);

    /*   if(autocompleteCustomers.length===0){
        setfilterClientId(null);  
       }  */
  };

  const onSuggestionsClearRequested = () => {
    setAutocompleteCustomers([]);
  };

  return (
    <React.Fragment>
      <Typography
        color="textPrimary"
        variant="h6"
        gutterBottom
        style={{ fontSize: 13, marginBottom: 20 }}
      >
        Filtrar Reporte
      </Typography>
      <ListItem style={{ padding: 0 }}>
        <ListItemText secondary="Por Cliente"></ListItemText>
      </ListItem>
      <ListItem style={{ padding: 0 }}>
        <Autosuggest
          suggestions={autocompleteCustomers}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={{
            placeholder: "  Ruc, DNI o nombre",
            value: buyerKey,
            onChange: (
              event: React.FormEvent<any>,
              { newValue, method }: Autosuggest.ChangeEvent
            ) => {
              setBuyerKey(newValue);
              if (newValue === "") {
                setfilterClientId(null);
                setName(null);
              }
            },
            ref: React.createRef<HTMLInputElement>(),
          }}
        />
      </ListItem>

      <List component="nav" aria-labelledby="nested-list-subheader">
        <ListItem
          button
          onClick={() => {
            setCollapseDocType(!collapseDocType);
          }}
        >
          <ListItemText secondary="Por tipo de documento"></ListItemText>
          {collapseDocType ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={collapseDocType} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Factura"
                control={
                  <RCheckbox
                    checked={docTypes.Facturas}
                    onChange={handleCheckDocType}
                    name="Facturas"
                  />
                }
              />
            </ListItem>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Boleta"
                control={
                  <RCheckbox
                    checked={docTypes.Boletas}
                    onChange={handleCheckDocType}
                    name="Boletas"
                  />
                }
              />
            </ListItem>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Nota de Crédito"
                control={
                  <RCheckbox
                    checked={docTypes.NotasCredito}
                    onChange={handleCheckDocType}
                    name="NotasCredito"
                  />
                }
              />
            </ListItem>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Nota de Débito"
                control={
                  <RCheckbox
                    checked={docTypes.NotasDebito}
                    onChange={handleCheckDocType}
                    name="NotasDebito"
                  />
                }
              />
            </ListItem>
          </List>
        </Collapse>
      </List>

      <List component="nav" aria-labelledby="nested-list-subheader">
        <ListItem
          button
          onClick={() => {
            setCollapseState(!collapseState);
          }}
        >
          <ListItemText secondary="Por estado de documento"></ListItemText>
          {collapseState ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={collapseState} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Autorizado"
                control={
                  <RCheckbox
                    checked={docStates.Autorizado}
                    onChange={handleCheckDocStates}
                    name="Autorizado"
                  />
                }
              />
            </ListItem>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Anulado"
                control={
                  <RCheckbox
                    checked={docStates.Anulado}
                    onChange={handleCheckDocStates}
                    name="Anulado"
                  />
                }
              />
            </ListItem>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Erróneo"
                control={
                  <RCheckbox
                    checked={docStates.Erroneo}
                    onChange={handleCheckDocStates}
                    name="Erroneo"
                  />
                }
              />
            </ListItem>

            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Rechazado"
                control={
                  <RCheckbox
                    checked={docStates.Rechazado}
                    onChange={handleCheckDocStates}
                    name="Rechazado"
                  />
                }
              />
            </ListItem>
            <ListItem style={{ padding: 0 }}>
              <FormControlLabel
                label="Pendiente"
                control={
                  <RCheckbox
                    checked={docStates.Pendiente}
                    onChange={handleCheckDocStates}
                    name="Pendiente"
                  />
                }
              />
            </ListItem>
          </List>
        </Collapse>
      </List>

      <List component="nav" aria-labelledby="nested-list-subheader">
        <ListItem
          button
          onClick={() => {
            setCollapseNumeral(!collapseNumeral);
          }}
        >
          <ListItemText secondary="Por numeral"></ListItemText>
          {collapseNumeral ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={collapseNumeral} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem>
              <TextField
                fullWidth
                label="Serie"
                variant="outlined"
                size="small"
                type="text"
                autoComplete="off"
                style={{ width: 180, paddingRight: 10 }}
                error={validSerie === false}
                value={filterSerie}
                onChange={(e) => {
                  if (e.target.value.length === 5) return;
                  setFilterSerie(e.target.value.toUpperCase());
                  if (!validSerie /* y es una serie valida */) {
                    setValidSerie(true);
                  }
                }}
              />
            </ListItem>
            <ListItem>
              <TextField
                fullWidth
                label="Secuencial Inicio"
                variant="outlined"
                size="small"
                type="number"
                autoComplete="off"
                style={{ width: 180, paddingRight: 10 }}
                error={validFilterInitSeq === false}
                value={filterInitSeq}
                onChange={(e) => {
                  if (
                    (e.target.value && !/^\d+$/.test(e.target.value)) ||
                    e.target.value.length === 9
                  )
                    return;
                  setFilterInitSeq(e.target.value);
                  if (!validFilterInitSeq && Number(e.target.value) > 0) {
                    setValidFilterInitSeq(true);
                  }
                }}
              />
            </ListItem>
            <ListItem>
              <TextField
                fullWidth
                label="Secuencial Fin"
                variant="outlined"
                size="small"
                type="number"
                autoComplete="off"
                style={{ width: 180, paddingRight: 10 }}
                error={validFilterEndSeq === false}
                value={filterEndSeq}
                onChange={(e) => {
                  if (
                    (e.target.value && !/^\d+$/.test(e.target.value)) ||
                    e.target.value.length === 9
                  )
                    return;
                  setFilterEndSeq(e.target.value);
                  if (
                    !validFilterEndSeq &&
                    Number(e.target.value) >= Number(validFilterInitSeq)
                  ) {
                    setValidFilterEndSeq(true);
                  }
                }}
              />
            </ListItem>
          </List>
        </Collapse>
      </List>
    </React.Fragment>
  );
};
